import { post , postToS3} from '@/services/webservice'
import {useLogger} from "@/composables/useLogger"
import { ref} from "vue"

export function useS3Upload() {
  const {sendLog} = useLogger()
  const file = ref(null)
  const url = ref(null)
  const fields = ref(null)
  const getPresignedS3Url = async (path, selectedFile) => {
    const query = `
           query GetPresignedS3Url($entityPath: String!,$filename: String! ) {
        getPresignedS3Url(entityPath:$entityPath, filename:$filename )
    },
  `;
    const variables = {
        "entityPath": path,
        "filename": selectedFile.name
    }
    const {data} = await post('/graphql', {
        query: query,
        variables
    })
    file.value = selectedFile
    url.value = data.data.getPresignedS3Url.url
    fields.value = data.data.getPresignedS3Url.fields
  }

  const uploadToS3 = async () => {
    try{
        const formData = new FormData()
        Object.entries(fields.value).forEach(([k, v]) => formData.append(k,v))
        formData.append("file", file.value)

        await postToS3(url.value, formData)
        return fields.value.key
      }
      catch (error) {
          sendLog("error", "uploadToS3", {error, metadata: {fileName: file.value.name, url: url.value}})
          throw error;
      }
  }

  const reset = () => {
    file.value = null
    url.value = null
    fields.value = null
  }

  const hasNewFile =  () => {
    return file.value ? true : false 
  } 

  return {
    getPresignedS3Url,
    uploadToS3,
    reset,
    hasNewFile
  }
}